import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MailService } from '../../services/email.service';
import { EEntityType } from '../../models/entity-type.enum';
import { RegionService } from '../../../core/services/region.service';
import { Unsubscriber } from '../../../core/unsubscriber/unsubscriber';
import { IOfferRegionListItem } from '../../../core/models/offer-region';
import { SnackbarService } from '../../services/snackbar.service';
import { EMailType, IEmailMessage } from '../../models/email.model';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'brf-subscribe-offer-newsletter-dialog',
  templateUrl: './subscribe-offer-newsletter.component.html',
  styleUrls: ['./subscribe-offer-newsletter.component.scss']
})
export class SubscribeOfferNewsletterDialogComponent extends Unsubscriber implements OnInit {
  form: UntypedFormGroup;
  message: string;
  inputEmail = '';

  entityType: EEntityType;
  emailType: EMailType;

  hasSent: boolean = false;
  isSending: boolean = false;
  allRegions: IOfferRegionListItem[];

  constructor(
    private mailService: MailService,
    private regionService: RegionService,
    private formBuilder: UntypedFormBuilder,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SubscribeOfferNewsletterDialogComponent>,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
    this.inputEmail = data?.email ?? '';

    this.addSubscription(
      this.regionService.getAllSwedishRegions().subscribe(data => {
        this.allRegions = data;
      })
    );
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      companyName: ['', [Validators.required, Validators.minLength(3)]],
      city: ['', [Validators.required, Validators.minLength(3)]],
      orgNo: ['', [Validators.pattern(/^([a-zA-Z0-9]{6}-[a-zA-Z0-9]{4})$/)]],
      customerName: [''],
      regionIds: this.formBuilder.array([], [Validators.required])
    });

    if (this.inputEmail && this.inputEmail.length > 0) {
      this.form.controls['email'].setValue(this.inputEmail);
    }
  }

  get regionIds(): FormArray {
    return this.form.get('regionIds') as FormArray;
  }

  close() {
    this.dialogRef.close();
  }

  onRegionToggle(regionId: number, checked: boolean) {
    if (checked) {
      this.regionIds.push(this.formBuilder.control(regionId));
    } else {
      const index = this.regionIds.controls.findIndex(x => x.value === regionId);
      this.regionIds.removeAt(index);
    }
  }

  onSubmit() {
    let listRegionIds: string[] = this.regionIds.value;

    let model = {
      email: this.form.controls['email'].value,
      companyName: this.form.controls['companyName'].value,
      city: this.form.controls['city'].value,
      orgNo: this.form.controls['orgNo'].value,
      customerName: this.form.controls['customerName'].value,
      regionNames: listRegionIds.map(k => this.allRegions.find(j => j.id == k).name),
      pageUrl: this.document.location.href
    };

    var mail: IEmailMessage = {
      emailType: EMailType.BRFSubscribeOfferNewsletter,
      dataPayload: JSON.stringify(model)
    };

    this.isSending = true;
    this.addSubscription(
      this.mailService.sendEmailWithType(mail).subscribe({
        next: result => {
          if (result.message == 'i18nMsg.EmailPushSuccess') {
            this.hasSent = true;
            this.isSending = false;
          }
        },
        error: error => {
          this.isSending = false;
          this.snackbarService.displayMessage('Kan inte skicka meddelande, försök senare!');
        }
      })
    );
  }
}
